/**
 * Meteorit LP UI — nav, sticky CTA, FAQ, scroll reveal.
 * Selectors are limited to .sslp-page so embed mode does not touch the rest of the theme.
 */
(function () {
  'use strict';

  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 30);
    }, { passive: true });
  }

  var stickyCta = document.getElementById('sticky-cta');
  var heroEl = document.getElementById('hero');
  var finalCtaEl = document.getElementById('bestellen');

  if (stickyCta && heroEl && finalCtaEl) {
    var stickyLink = stickyCta.querySelector('a');
    function updateSticky() {
      var heroBottom = heroEl.getBoundingClientRect().bottom;
      var finalTop = finalCtaEl.getBoundingClientRect().top;
      var shouldShow = heroBottom < 0 && finalTop > window.innerHeight;
      stickyCta.classList.toggle('show', shouldShow);
      stickyCta.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (stickyLink) stickyLink.tabIndex = shouldShow ? 0 : -1;
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  }

  /**
   * FAQ uses native <details name="sslp-faq"> where supported (exclusive accordion).
   * This listener closes other rows when one opens — needed for older browsers without name= support.
   */
  document.querySelectorAll('.sslp-page details.faq-item').forEach(function (row) {
    row.addEventListener('toggle', function () {
      if (!row.open) return;
      document.querySelectorAll('.sslp-page details.faq-item').forEach(function (other) {
        if (other !== row && other.open) other.removeAttribute('open');
      });
    });
  });

  document.querySelectorAll('.sslp-page a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /** Rotating SSLP announcement bar — mobile only (≤768px), seamless loop */
  document.querySelectorAll('.sslp-page .announce-bar[data-announce-rotate]').forEach(function (bar) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var track = bar.querySelector('.announce-bar__track');
    if (!track || track.children.length <= 1) return;

    var mobileMql = window.matchMedia('(max-width: 768px)');
    var intervalSec = parseInt(bar.getAttribute('data-announce-interval'), 10);
    if (isNaN(intervalSec) || intervalSec < 2) intervalSec = 5;
    var ms = intervalSec * 1000;
    var dur = 450;

    var total = track.children.length;
    var index = 0;
    var timer = null;

    function resetTrack() {
      index = 0;
      track.style.transition = 'none';
      track.style.transform = 'translateX(0)';
    }

    function slideNext() {
      index += 1;
      track.style.transition = 'transform ' + dur / 1000 + 's ease';
      track.style.transform = 'translateX(-' + index * 100 + '%)';

      if (index === total - 1) {
        setTimeout(function () {
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          index = 0;
        }, dur);
      }
    }

    function start() {
      if (timer || !mobileMql.matches) return;
      resetTrack();
      timer = setInterval(slideNext, ms);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      resetTrack();
    }

    function onViewportChange() {
      if (mobileMql.matches) start();
      else stop();
    }

    if (mobileMql.addEventListener) {
      mobileMql.addEventListener('change', onViewportChange);
    } else {
      mobileMql.addListener(onViewportChange);
    }

    onViewportChange();
  });

  var revealEls = document.querySelectorAll('.sslp-page .reveal');
  if (revealEls.length === 0) return;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 0px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  // Fallback: on some mobile browsers IntersectionObserver silently fails to fire.
  // After 2 s, reveal any elements that are still hidden.
  setTimeout(function () {
    revealEls.forEach(function (el) {
      if (!el.classList.contains('in-view')) el.classList.add('in-view');
    });
  }, 2000);
})();
